import React from 'react';
import Main from "./components/Main";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
